import dynamic from "next/dynamic";
import IframeDynamicWidthIframeConfig from "./iframe-dynamic-width-iframe-config";
import IframeDynamicWidthIframeAdvancedConfig from "./iframe-dynamic-width-iframe-advanced-config";
const IframeDynamicWidthIframeComponent = dynamic(()=>import("./iframe-dynamic-width-iframe-component"));
export default {
    IframeDynamicWidthIframeComponent,
    IframeDynamicWidthIframeConfig,
    IframeDynamicWidthIframeAdvancedConfig
};
